// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { reducers } from "@insite/client-framework/Store/Reducers";
import { Draft } from "immer";

export type xSpecialRequestItemsStateType = Readonly<{
    priceRange?: { displayName?: string; value?: string }[];
}>;

export const initialSpecialRequestItemsState: xSpecialRequestItemsStateType = {
    priceRange: [],
};

const reducer = {
    "xSpecialRequestItemsState/CompleteLoadPriceRange": (
        draft: Draft<xSpecialRequestItemsStateType>,
        action: { priceRange: xSpecialRequestItemsStateType["priceRange"] },
    ) => {
        draft["priceRange"] = action.priceRange;
    },
};

const xSpecialRequestItemsState = createTypedReducerWithImmer(initialSpecialRequestItemsState, reducer);

(reducers as any).xSpecialRequestItems = xSpecialRequestItemsState;

export type xSpecialRequestItemsState = {
    xSpecialRequestItems: xSpecialRequestItemsStateType;
} & ApplicationState;
